"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
require("./TextBox.css");
var sizeStyles = {
    small: { height: 28, fontSize: 13, padding: '0 8px' },
    medium: { height: 32, fontSize: 15, padding: '0 12px' },
    large: { height: 32, fontSize: 17, padding: '0 16px' },
};
var TextBox = function (_a) {
    var onChange = _a.onChange, value = _a.value, iconUrl = _a.iconUrl, _b = _a.style, style = _b === void 0 ? {} : _b, _c = _a.textBoxBackground, textBoxBackground = _c === void 0 ? "#fff" : _c, _d = _a.textBoxText, textBoxText = _d === void 0 ? "#000" : _d, _e = _a.type, type = _e === void 0 ? "text" : _e, _f = _a.placeholder, placeholder = _f === void 0 ? "Search" : _f, onBlur = _a.onBlur, _g = _a.themeMode, themeMode = _g === void 0 ? "dark" : _g, _h = _a.error, error = _h === void 0 ? false : _h, _j = _a.helperText, helperText = _j === void 0 ? "" : _j, inputRef = _a.inputRef, label = _a.label, onKeyDown = _a.onKeyDown, _k = _a.size, size = _k === void 0 ? "medium" : _k, _l = _a.disabled, disabled = _l === void 0 ? false : _l;
    var _m = (0, react_1.useState)(false), isRevealPwd = _m[0], setIsRevealPwd = _m[1];
    var internalInputRef = (0, react_1.useRef)(null);
    // Get the actual input ref (either internal or external)
    var getInputRef = function () {
        if (inputRef && typeof inputRef === 'object' && 'current' in inputRef) {
            return inputRef.current;
        }
        return internalInputRef.current;
    };
    var handleType = function () {
        if (type === "phoneNumber")
            return "text";
        return type === "text" ? "text" : isRevealPwd ? "text" : "password";
    };
    var formatPhoneNumber = function (inputValue) {
        // Remove all non-digits from the input
        var numbersOnly = inputValue.replace(/\D/g, '');
        // Limit to 10 digits
        var limitedNumbers = numbersOnly.slice(0, 10);
        // Format: +1 (XXX) XXX-XXXX
        if (limitedNumbers.length <= 3) {
            return limitedNumbers;
        }
        else if (limitedNumbers.length <= 6) {
            return "(".concat(limitedNumbers.slice(0, 3), ") ").concat(limitedNumbers.slice(3));
        }
        else {
            return "(".concat(limitedNumbers.slice(0, 3), ") ").concat(limitedNumbers.slice(3, 6), "-").concat(limitedNumbers.slice(6, 10));
        }
    };
    var handlePhoneNumberChange = function (event) {
        var inputValue = event.target.value;
        // Remove the +1 prefix if user tries to modify it
        var valueWithoutPrefix = inputValue.replace(/^\+1\s*/, '');
        // Only allow digits, spaces, parentheses, and hyphens
        var filteredValue = valueWithoutPrefix.replace(/[^\d\s\(\)\-]/g, '');
        // Create a new event with the formatted value
        var formattedValue = formatPhoneNumber(filteredValue);
        var newEvent = __assign(__assign({}, event), { target: __assign(__assign({}, event.target), { value: formattedValue }) });
        onChange(newEvent);
    };
    var handleInputChange = function (event) {
        if (type === "phoneNumber") {
            handlePhoneNumberChange(event);
        }
        else {
            onChange(event);
        }
    };
    var getDisplayValue = function () {
        if (type === "phoneNumber") {
            return value ? "+1 ".concat(value) : "+1 ";
        }
        return value;
    };
    // Enhanced phone number key handling
    var getPhoneNumberKeyDown = function (event) {
        var input = event.target;
        var cursorPosition = input.selectionStart || 0;
        var cursorEnd = input.selectionEnd || 0;
        // Prevent deletion or modification of +1 prefix
        if ((event.key === 'Backspace' || event.key === 'Delete') && cursorPosition <= 3) {
            event.preventDefault();
            return;
        }
        // Prevent moving cursor into the +1 prefix with arrow keys
        if (event.key === 'ArrowLeft' && cursorPosition <= 3) {
            event.preventDefault();
            return;
        }
        // Prevent Home key from going to beginning of +1
        if (event.key === 'Home') {
            event.preventDefault();
            setTimeout(function () {
                if (input) {
                    input.setSelectionRange(3, 3);
                }
            }, 0);
            return;
        }
        // Handle selection that includes the +1 prefix
        if ((event.key === 'Backspace' || event.key === 'Delete') && cursorPosition < 3 && cursorEnd > 3) {
            event.preventDefault();
            return;
        }
        // Only allow numbers, navigation keys, and some special keys for phone input
        var allowedKeys = [
            'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown',
            'Home', 'End', 'Tab', 'Enter', 'Escape', 'F5', 'F12'
        ];
        // Allow Ctrl+A, Ctrl+C, Ctrl+V, etc.
        if (event.ctrlKey || event.metaKey) {
            return;
        }
        if (!allowedKeys.includes(event.key) && !/\d/.test(event.key)) {
            event.preventDefault();
        }
        // Call the original onKeyDown if provided
        if (onKeyDown) {
            onKeyDown(event);
        }
    };
    var handleKeyDown = function (event) {
        if (type === "phoneNumber") {
            getPhoneNumberKeyDown(event);
        }
        else if (onKeyDown) {
            onKeyDown(event);
        }
    };
    // Handle mouse/click events for phone number
    var handlePhoneNumberClick = function (event) {
        if (type === "phoneNumber") {
            var input_1 = event.target;
            setTimeout(function () {
                var cursorPosition = input_1.selectionStart || 0;
                if (cursorPosition < 3) {
                    input_1.setSelectionRange(3, 3);
                }
            }, 0);
        }
    };
    // Handle focus for phone number
    var handlePhoneNumberFocus = function (event) {
        if (type === "phoneNumber") {
            var input_2 = event.target;
            setTimeout(function () {
                // Set cursor to after +1 prefix if the field is empty or cursor is in prefix
                if (!value || input_2.selectionStart < 3) {
                    input_2.setSelectionRange(3, 3);
                }
            }, 0);
        }
    };
    var mergedStyles = __assign(__assign({}, style), { background: textBoxBackground });
    var getShowUrl = function () {
        return themeMode === "dark" ? "/icons/show-white.png" : "/icons/show.png";
    };
    var getHideUrl = function () {
        return themeMode === "dark" ? "/icons/hide-white.png" : "/icons/hide.png";
    };
    var getPlaceholder = function () {
        if (type === "phoneNumber") {
            return "+1 (555) 123-4567";
        }
        return placeholder;
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        label && (react_1.default.createElement("label", { style: { marginBottom: 4, display: 'block', color: themeMode === 'dark' ? '#fff' : '#000', fontSize: 13, fontWeight: 500 } }, label)),
        react_1.default.createElement("div", { className: "search-container", style: __assign(__assign({}, mergedStyles), { border: error ? "1.5px solid #ff4e3a" : "1px solid #636279", outline: error ? "1.5px solid #ff4e3a" : undefined, cursor: disabled ? "not-allowed" : "text" }) },
            iconUrl && react_1.default.createElement("img", { className: "search-icon", src: iconUrl, alt: "icon" }),
            react_1.default.createElement("input", { ref: inputRef || internalInputRef, type: handleType(), className: "search-input", placeholder: getPlaceholder(), style: __assign({ background: textBoxBackground, color: textBoxText, WebkitTextFillColor: textBoxText, WebkitBoxShadow: "0 0 0 1000px ".concat(textBoxBackground, " inset") }, sizeStyles[size]), value: getDisplayValue(), onChange: handleInputChange, autoComplete: "off", onBlur: onBlur, onKeyDown: handleKeyDown, onClick: handlePhoneNumberClick, onFocus: handlePhoneNumberFocus, disabled: disabled }),
            type === "password" && (react_1.default.createElement("img", { className: "search-icon", onClick: function () { return setIsRevealPwd(!isRevealPwd); }, src: isRevealPwd ? getHideUrl() : getShowUrl(), alt: "toggle visibility" }))),
        error && helperText && (react_1.default.createElement("div", { style: { color: "#ff4e3a", fontSize: "0.85em", marginTop: "0.35em", marginLeft: "0.5em" } }, helperText))));
};
exports.default = TextBox;
